import { inject, injectable } from 'tsyringe';
import { RecommendationDatastoreService } from '../../datastore-service/recommendation-datastore.service';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { LoggerService } from '../../logger.service';
import { IOWUtilsWrapper } from '../../../interfaces/ow-wrappers/ow-utils-wrapper.interface';
import { kDITOWUtilsWrapper } from '../../../constants/injectionTokens';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.Global)
export class GlobalConditionUserPhasing implements ICondition {
  private readonly logger = LoggerService.getCategory(
    'GlobalConditionUserPhasing',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly datastoreService: RecommendationDatastoreService,
    @inject(kDITOWUtilsWrapper)
    private readonly owUtilsWrapper: IOWUtilsWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const configs = await this.datastoreService.getGlobalConfigurations();
    if (!configs) {
      return [false, NoRecommendationsReasons.FailedToGetServiceConfig];
    }

    const { game } = context;

    const userPersistentPhase =
      await this.owUtilsWrapper.getPersistentPhasedPercent();

    const calculatedPhasedPercent = (userPersistentPhase + game.id) % 100;

    this.logger.info(
      `calculatedPhasedPercent = ${userPersistentPhase} (user) + ` +
        `${game.id} (game) % 100 = ${calculatedPhasedPercent}`,
    );

    this.logger.info(`game.recommendPercent = ${game.recommendPercent}`);

    const matches = calculatedPhasedPercent <= game.recommendPercent;

    const reason = matches
      ? undefined
      : NoRecommendationsReasons.UserPersistentPhasing;

    return [matches, reason];
  }
}
